var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareArrowNew = function SvgShareArrowNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.525 14H0V6.397c-.001-.52.12-1.032.352-1.496a3.994 3.994 0 0 1 3.626-2.334h3.994V0h1.24L14 4.775 9.194 9.567H7.972V7H5.375a2.5 2.5 0 0 0-2.399 1.815z"
  })));
};
export default SvgShareArrowNew;